export enum FiFilterType {
    Category,
    LastEdit,
    Tag,
    CustomDate,
    Checklist, // Checklist v2
    Schedule, // Checklist v2
    Checkpoint, // Checklist v2
    CheckpointGroup, // Checklist v2
    CheckpointStatus, // Checklist v2
    TaskName, // task v2 report
    TaskStatus, // task v2 report
    TaskPriority, // task v2 report
    TaskCategory, // task v2 report
    Onboarding, // Onboarding report
    OnboardingCategory, // Onboarding report
    Role, // task v2 report
    BusinessUnit,
    Area,
    BusinessArea,
    User,
    Cluster,
}

export const FilterTypeLabelSet: { [key in FiFilterType]?: string } = {
    [FiFilterType.Schedule]: 'checklist.checklist_schedules',
    [FiFilterType.Checklist]: 'checklist.module_name',
    [FiFilterType.Checkpoint]: 'checklist.checkpoints',
    [FiFilterType.CheckpointGroup]: 'checklist.add_section',
    [FiFilterType.BusinessUnit]: 'common.units',
    [FiFilterType.Area]: 'common.areas',
    [FiFilterType.BusinessArea]: 'common.business_areas',
    [FiFilterType.Role]: 'common.roles',
    [FiFilterType.User]: 'common.users',
    [FiFilterType.CheckpointStatus]: 'form.answer',
    [FiFilterType.TaskName]: 'task.tasks',
    [FiFilterType.TaskStatus]: 'common.status',
    [FiFilterType.TaskPriority]: 'common.priority',
    [FiFilterType.TaskCategory]: 'common.category',
    [FiFilterType.Onboarding]: 'onboarding.onboardings',
    [FiFilterType.OnboardingCategory]: 'common.category',
} as const;

export const SelectedItemsMaxAmountChecklistBenchmark: { [key in FiFilterType]?: number } = {
    [FiFilterType.BusinessUnit]: 20,
    [FiFilterType.Checkpoint]: 4,
    [FiFilterType.CheckpointGroup]: 4,
    [FiFilterType.Schedule]: 4,
} as const;
